import React, { memo } from 'react';

import moment from 'moment';
import { useQuery } from '@tanstack/react-query';

import Table from '../../Table';

import ReportService from '../../../services/ReportService';

const cols = [
  {
    title: 'Date',
    keys: ['date'],
    format: (value) => moment(value).format('M/D/YY'),
    link: (row) => `/loans/${row.loan_id}/payments/${row.id}?tab=Payment`,
  },
  {
    title: 'Loan',
    keys: ['_loan._property.address_line_1'],
    link: (row) => `/loans/${row.loan_id}?tab=Property`,
  },
  {
    title: 'Borrower',
    keys: ['doesntmatter'],
    format: (_, row) =>
      row?._loan?._borrower_primary?.TIN_type === 'EIN'
        ? row?._loan?._borrower_primary?.entity_name
        : `${row?._loan?._borrower_primary?.first_name} ${row?._loan?._borrower_primary?.last_name}`,
    link: (row) => `/loans/${row.loan_id}?tab=Borrowers`,
  },
  {
    title: 'Amount',
    keys: ['amount'],
    type: 'currency',
    link: (row) => `/loans/${row.loan_id}/payments/${row.id}?tab=Payment`,
  },
  {
    title: 'Status',
    keys: ['status'],
    link: (row) => `/loans/${row.loan_id}/payments/${row.id}?tab=Payment`,
  },
  {
    title: 'Source',
    keys: ['source'],
    link: (row) => `/loans/${row.loan_id}/payments/${row.id}?tab=Payment`,
  },
  {
    title: 'Reference',
    keys: ['reference'],
    link: (row) => `/loans/${row.loan_id}/payments/${row.id}?tab=Payment`,
  },
  {
    title: 'Distributied',
    keys: ['distributed'],
    type: 'checkbox',
    isSelected: (row) => row.distributed,
    disabled: () => true,
  },
];

function UndepositedChecksTable() {
  const { data: undepositedChecks } = useQuery({
    queryKey: ['undepositedChecks'],
    queryFn: ReportService.getUndepositedChecks,
  });

  if (!undepositedChecks || !undepositedChecks.length) {
    return null;
  }

  return (
    <Table cols={cols} rows={undepositedChecks} title="Undeposited Checks" />
  );
}

export default memo(UndepositedChecksTable);
